

/**
 * Show instant price product actions
 *
 * @param {}
 * @return {void}
 */

jQuery( document ).on( 'keyup', '.js-field-measurement', function( e ) {
  if (e.key === 'Enter' || e.keyCode === 13) {
    // Do something
    jQuery( '.js-show-instant-price-actions' ).click();
  }
});


$(document).on('click', '.js-show-instant-price-actions', function(e) {
  e.preventDefault();

  const $actions = $('.js-instant-price-actions');
  const activeClass = 'is-active';
  var ndd_value = jQuery("#ndd_checkbox").is(":checked");

  jQuery( '.product__final' ).show();
  jQuery( 'h3.js-not-available' ).remove();
  jQuery( '.product__final-price' ).text( 'Fetching your price...' );
  jQuery( '.js-show-instant-price-actions .btn__text' ).text( 'Fetching your price...' );

  var width, origWidth, drop, origDrop;

  width = origWidth = $("#field-min-width").val();
  drop = origDrop = $("#field-min-drop").val();

  var units = $("input[name='radio-measurement']:checked").val();

  switch(units) {
    case "cm":
        width = width * 10;
        drop = drop * 10;
        break; 
    case "inches":
        width = width * 25.4;
        drop = drop * 25.4; 
        break;
  }

  $(".js-instant-price-actions .product__actions-inner h4").empty().append(origWidth+""+units+" width x "+origDrop+""+units+" drop");

  new Promise((resolve, reject) => {
  
    if("undefined" != typeof oTags && "undefined" != typeof oTags.PRICE_TABLE_KEY) {
  
      var fromPriceQueryUrl = "https://"+window.OsGlobals.domain+"/priceLookup.js?key="+oTags.PRICE_TABLE_KEY+"&width="+width+"&drop="+drop+"&callback=customPrice&ndd_value="+ndd_value;
      // var fromPriceQueryUrl = "http://localhost/priceLookup.js?key="+oTags.PRICE_TABLE_KEY+"&width="+width+"&drop="+drop+"&callback=customPrice";

      // Does this have eyelets selected
      if( jQuery( '[name="data[Heading]"]:checked' ).val() == 'Eyelet|EYELET' ) {
        fromPriceQueryUrl = fromPriceQueryUrl + "&withEyelets=true";
      } 
  
      let loadScript = document.createElement("script");
  
      loadScript.onload = resolve; 
      loadScript.onerror = reject;
  
      loadScript.async = true;
      loadScript.src = fromPriceQueryUrl;
      document.getElementsByTagName("head")[0].appendChild(loadScript);
    }
  });

});

/**
 * VELUX / Roof Blind Behaviour
 */

//*
(function($) {
  $(function(){
    

    $("#velux-add-to-bag").hide();

    //used in ajax-actions.js to control logic for add to basket makevarient URL
    window.isVelux = false;
    
    //fetch data from middleware
    new Promise((resolve, reject) => {  
      if("undefined" != typeof oTags && "undefined" != typeof oTags.PRICE_TABLE_KEY && oTags.PRICE_TABLE_KEY == 'velux-A') {

        var aPath = document.location.pathname .split("/");
        var sHandle = aPath[aPath.length-1];
        var aHandle = sHandle.split("-");

        var colour = aHandle[1];
        var make = aHandle[5];

        colour = colour[0].toUpperCase() + colour.substring(1);
        make = make[0].toUpperCase() + make.substring(1);


        var fromPriceQueryUrl = "https://"+window.OsGlobals.domain+"/priceLookup.js?key=velux&callback=veluxPricing&make="+make+"&colour="+colour;

        let loadScript = document.createElement("script");

        loadScript.onload = resolve;
        loadScript.onerror = reject;

        loadScript.async = true;
        loadScript.src = fromPriceQueryUrl;
        document.getElementsByTagName("head")[0].appendChild(loadScript);
      }
    }); 

    var $sizeCodeContainer = jQuery( '<select></select>' );

    //populate the frame codes from shopify/assets/velux-frame-codes.js <-- loaded directly on PDP when roof blind
    $("#frame-code").parent().on("change", "#frame-code", function(){
      var fc = $(this).val();
      
      if( $sizeCodeContainer.find( 'option' ).length == 0 ) {
        $sizeCodeContainer.append( $("#velux-size option.js-velux-size").clone() );
        $sizeCodeContainer.find( 'option' ).show();
      }

      $("#velux-size option.js-velux-size").remove();
      $("#velux-size option.js-please-select").focus().attr("selected","selected");
      $("#velux-size").val('-').trigger( 'change' );
      var sizes = window.veluxFrameCodes[fc];

      if( fc == "all" ) {
        $("#velux-size").append( $sizeCodeContainer.find( "option" ).clone() );
      } else {
        for(var i in sizes) {
          var size = sizes[i];
          $("#velux-size").append( $sizeCodeContainer.find( "option[value='"+size+"']" ).clone() );
        }
      }

  
    });

    $("#velux-size").parent().on("change", "#velux-size", function(){
      //$("#velux-add-to-bag").show();

      //used in ajax-actions.js to control logic for add to basket makevarient URL
      window.isVelux = true;

      $(".js-instant-price-actions h4").remove();
      $(".js-instant-price-actions button").removeAttr('disabled');
      $(".js-instant-price-actions button .btn__text").empty().append('Add To Bag');

      $(".js-instant-price-actions").show();
      $(".product__final").show();
      $("h3.js-not-available").remove();
      
      window.velux = {};

      var price = $("option:selected",$(this)).attr('data-price');

      window.velux.product_code = $("option:selected",$(this)).attr('data-product_code');
      window.velux.description = $("option:selected",$(this)).attr('data-desc');
      window.velux.make = $("option:selected",$(this)).attr('data-make');
      window.velux.colour = $("option:selected",$(this)).attr('data-colour');
      window.velux.size = $("option:selected",$(this)).attr('data-size');
          
      var formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
      });

      if( jQuery( '#velux-size option:selected' ).val() == '-' ) {
        jQuery( ".js-instant-price-actions" ).hide();
      } else {
        jQuery( ".js-instant-price-actions" ).show();
      }


      var from = formatter.format(price);
      jQuery( ".product__final-price" ).html( "Our price just: <span class='value'></span>" );
      $(".product__final-price .value").empty().append(from);

    });

  });
})(jQuery);
    

/**
 * triggered by jsonp callback.
 * middleware gets all the prices from google sheets and returns just the sizes and codes for this PDP
 * PDP = make (brand) & colour
 * customer needs to choose a size code. Each size has a price & product code
 * price is shown, (product code sent back to middleware on add to bag)
 */

window.veluxPricing = function (data) {
  var $ = window.OsGlobals.jQuery;   
  var frames = [];

  var options = [];
  options.push("<option class='js-please-select' value='-'>Select size code</option>");

  var make;

  for(var key in data) {

    var attrs = "data-product_code='"+data[key].product_code
      + "' data-make='"+data[key].make
      + "' data-colour='"+ data[key].colour
      + "' data-desc='" + data[key].description
      + "' data-size = '"+key+"' ";

    if(make == 'Velux') {
      options.push("<option value='"+key+"' "+attrs+" data-price='"+data[key].price+"' class='js-velux-size'>"+key+"</option>");
    } else {
      options.push("<option value='"+key+"' "+attrs+" data-price='"+data[key].price+"' class='js-velux-size'>"+data[key].size+"</option>");
    }

    make = data[key].make;
  }
  $("#velux-size").empty().append(options.join("\n"));


  //velux branded windows get the frame code drop down

  if(make == 'Velux') {

    $("#velux-size option.js-velux-size").hide();
    $("#frame-code").empty().append("<option>Select window type code</option>").append("<option value='all'>All window codes</option>");
    for(key in window.veluxFrameCodes) {
      $("#frame-code").append("<option value='"+key+"'>"+key+"</option>");
    }

    // Show both dropdowns
    $("#frame-code").closest('.form__controls').show();
    $("#velux-size").closest('.form__controls').show();
  } else {
    // show only size
    $("#velux-size").closest('.form__controls').show();
  }


  jQuery( '.lds-roller' ).remove();

}
//*/
